import { useForm, UseFormReturn, Path, FieldValues } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

/**
 * Custom hook for form management with Zod validation
 */
export function useZodForm<T extends z.ZodType<any, any>>(
  schema: T,
  options?: {
    defaultValues?: Partial<z.infer<T>>;
    mode?: "onChange" | "onBlur" | "onSubmit" | "onTouched" | "all";
  },
): UseFormReturn<z.infer<T>> {
  return useForm<z.infer<T>>({
    resolver: zodResolver(schema),
    mode: options?.mode || "onSubmit",
    defaultValues: options?.defaultValues as any,
  });
}

/**
 * Utility to get form field props for HeroUI components
 */
export function getFieldProps<T extends FieldValues>(
  formState: UseFormReturn<T>,
  fieldName: Path<T>,
) {
  const {
    register,
    formState: { errors },
  } = formState;
  const error = errors[fieldName];

  return {
    ...register(fieldName),
    errorMessage: error?.message as string,
    isInvalid: !!error,
  };
}
